export default "__VITE_ASSET__15d62429__"